import Vue from 'vue'
import Dropdown from '@/components/dropdown/Dropdown.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    name: 'dropdown-select',
    data () {
        return {
            scroll: false,
            container: document.body
        }
    },
    props: {
        list: {
            type: Array,
            default: () => []
        },
        value: {
            default: null, // String | Object | Array<object>
        },
        /**
         * при множественном выборе
         * предполагается, что выбираться будут все
         * по умолчанию, поэтому в этом случае placeholder
         * обязателен
         */
        placeholderAll: {
            type: String,
            default: 'global.all'
        },
        name: String,
        /**
         * максимальное количество показа элементов
         */
        max: {
            type: Number,
            default: 8,
        },
        /**
         * классы стилей
         */
        type: {
            type: String,
        },
        /**
         * будет ли emit input 
         * всего обекта, а не только поля имени
         */
        isValueObject: {
            type: Boolean,
            default: false
        },
        idField: {
            type: String,
            default: 'id'
        },
        nameField: {
            type: String,
            default: 'name'
        }
    },
    computed: {
        selected() {
            if (Array.isArray(this.value)) {
                return this.value.length !== 0
            }
            return !!this.value
        },
        valueText() {
            if (Array.isArray(this.value)) {
                if (!this.value.length || this.value.length === this.list.length) {
                    return this.placeholderAll
                }
                if (this.value.length === 1) {
                    return this.value[0][this.nameField]
                }
                return this.value.length
            }
            if (this.value !== null && this.value !== undefined) {
                if (typeof this.value === 'object') {
                    return this.value[this.nameField]
                }
                /**
                 * Поскольку мы отправляем id как значение (для компонента карты)
                 * то нужно найти текст значения в самих опциях
                 * 
                 * 
                 * !!лучше НЕ строгое равенство
                 */
                const listOption = this.list.find(option => option[this.idField] == this.value)
                if (listOption) {
                    return listOption[this.nameField]
                }
                return this.value
            }
            return ''
        },
        getOptionName() {
            return option => {
                if (typeof option === 'object') {
                    return option[this.nameField]
                }
                return option
            }
        },
        getOptionActive() {
            return option => {
                /**
                 * пока рассматривается ТОЛЬКО сценарий массива объектов
                 */
                if (Array.isArray(this.value)) {
                    return this.value.find(valueItem => valueItem[this.idField] === option[this.idField])
                }
                if (this.isValueObject) {
                    return this.value[this.idField] === option[this.idField]
                }
                /**
                 * отправляем мы именно idField (для компоенента карты)
                 */
                return option[this.idField] === this.value
            }
            
        }
    },
    methods: {
        emitValue(emitedValue) {
            this.$emit('update:value', emitedValue)
            this.$emit('change', emitedValue)
            this.$emit('input', emitedValue)
            this.$emit('blur')
        },
        select(item) {
            
            let emitedValue = item
            /**
             * пока рассматривается ТОЛЬКО сценарий массива объектов
             */
            if (Array.isArray(this.value)) {
                emitedValue = [...this.value]
                const itemIndexValue = emitedValue.findIndex(valueItem => valueItem[this.idField] === item[this.idField])
                if (itemIndexValue !== -1) {
                    emitedValue.splice(itemIndexValue, 1)
                } else {
                    emitedValue.push(item)
                }
            } else if (this.isValueObject) {
                emitedValue = item
            } else {
                /**
                 * отправляем мы именно idField (для компоенента карты)
                 */
                emitedValue = typeof item === 'object' ? item[this.idField] : item
            }
            this.emitValue(emitedValue)
        },
        selectAll() {
            let emitedValue = []
            if (this.value.length < this.list.length) {
                emitedValue = [ ...this.list ]
            }
            this.emitValue(emitedValue)
        },
        openDropdown() {
            let option = this.$refs.scroll.$el.getElementsByClassName('first')[0]
            let content = this.$refs.options
            let wrap = this.$refs.wrap

            if (option && content) {
                this.$nextTick(() => {
                    let itemHeight = option.clientHeight + this.getStyleValue(option, 'marginBottom') + this.getStyleValue(option, 'marginTop')
                    let maxHeight = itemHeight * this.max + this.getStyleValue(wrap, 'paddingBottom') + this.getStyleValue(wrap, 'paddingTop')
                    let height =  this.list.length * itemHeight
                    this.scroll = height > maxHeight

                    content.style.height = this.scroll ? maxHeight + 'px' : 'auto'

                    this.$refs.scroll.update()
                    this.$emit('select:open')
                })
            }
        },
        getStyleValue(el, style) {
            return parseInt(window.getComputedStyle(el)[style])
        }

    },
    components: {
        Dropdown,
        VuePerfectScrollbar,
    }
}


// WEBPACK FOOTER //
// ./src/components/dropdownSelect/dropdownSelect.js